import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtrarAsignaturasIndicadores'
})
export class FiltrarAsignaturasIndicadoresPipe implements PipeTransform {

  transform(cursos: any[], busqueda: string): any[] {
    if (!cursos) return [];
    if (!busqueda) return cursos;
    cursos = JSON.parse(JSON.stringify(cursos))
    const result = [];

    cursos.forEach(nivel => {
      const cursosNivel = nivel.Cursos.filter(curso => {
        const secciones = curso.Secciones.filter(seccion => {
          const asignaturas = seccion.Asignaturas.filter(asignatura => {
            return asignatura.Nombre.toLowerCase().includes(busqueda.toLowerCase()) || 
              asignatura.Clave.toLowerCase().includes(busqueda.toLowerCase())
          });
          if (asignaturas.length > 0) {
            seccion.Asignaturas = asignaturas;
            return true;
          }
          return false;
        });
        if (secciones.length > 0) {
          curso.Secciones = secciones;
          return true;
        }
        return false;
      });
      if (cursosNivel.length > 0) {
        result.push({
          Nivel: nivel.Nivel,
          Cursos: cursosNivel
        });
      }
    });

    return result;
  }

}
